var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgRoomBlockAuto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "83px",
    viewBox: "0 0 45 83",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Parsing",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "HotelRoom-Block-Beta",
    transform: "translate(-578.000000, -383.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(552.000000, 376.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "sharp-flash_on-24px",
    opacity: 0.301176525,
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 91 0 91 92 0 92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#F5E478",
    fillRule: "nonzero",
    points: "27 8 27 49.8 38.4 49.8 38.4 84 65 38.4 49.8 38.4 61.2 8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "sharp-flash_on-24px"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0 0 92 0 92 92 0 92"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    stroke: "#FFE238",
    strokeWidth: 2,
    fillRule: "nonzero",
    points: "27 8 27 49.8 38.4 49.8 38.4 84 65 38.4 49.8 38.4 61.2 8"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomBlockAuto);
export default __webpack_public_path__ + "static/media/room-block-auto.e1fe1ecfaaea5838eb52d7b64fc167db.svg";
export { ForwardRef as ReactComponent };